
// Created by Johan Schram - KOSMEO ANALYTICS - https://kosmeo-a.com on 16/05/2017.

var React = require('react');
var CreateReactClass = require('create-react-class');
var PropTypes = require('prop-types');

import './area-finder-content.component.css';

import ParticipantLine from './participant-line.component';
import TimeContent from './time-content.component';
import Button from '../common/button.component';
import RightControl from './right-control.component';
//import AdressSelection from '../adressSelection/adress-selection.component';

import restService from '../../services/rest-service';
import leafletSrvc from '../../services/leaflet.service';
import participantService from '../../services/participants.service';


var areaFinderContent = CreateReactClass({
    propTypes : {
        position : PropTypes.number,
        handleHidePan : PropTypes.func,
        handleWaiter : PropTypes.func,
        updatePosition :  PropTypes.func,
        showAreaFinder :  PropTypes.func,
        dataToPlot :  PropTypes.any,
    },
    defaultProps : {
        dataToPlot : null
    },
    getInitialState: function () {
        return {
            participants : participantService.participants.list,
            canAddParticipant : true,
            calculOnProgress : false,
            legendeList: [],
            timePickerIsOpen : true,
            date : participantService.meetDateAndTime.meetDate,
            time : participantService.meetDateAndTime.meetTime,
        };
    },
    componentDidMount : function (){

        leafletSrvc.createMap();
        leafletSrvc.addClickEventToMapToAddParticipants(this.onclickOnMap, true);

        var el = document.getElementById('areaFinderContent');
        swipedetect(el, this.onSwipeComponent);

        const plotFromProps = ()=>{
            if (this.props.dataToPlot){
                if (this.props.dataToPlot.participants && this.props.dataToPlot.participants.length > 0 ){
                    this.getDataAndPlot(this.props.dataToPlot)
                }
            }
        };

        var a = setTimeout(plotFromProps.bind(this), 500)
    },
    componentWillUnmount: function () {
        // window.removeEventListener("message", this.handleFrameTasks);
        // document.removeEventListener("message", this.handleFrameTasks);
    },
    getDataAndPlot : function(data){

        // On supprime tous les participants
        this.changeCanAddParticipant(true);
        leafletSrvc.clearAll();
        participantService.participants.clearAll();

        // On ajoute tous les participants
        data.participants.forEach((item)=>{
            participantService.participants.addWithData(item)
        });

        this.setState({
            participants : participantService.participants.list,
            legendeList : []
        }, this.props.updatePosition());

        // On plot tous les participants
        participantService.participants.list.forEach((item)=>{
            leafletSrvc.plotParticipant(item.id, this.onDragParticipant)
        });

        // On met à jour la date et le l'heure
        if (data.time && data.time !== ''){
            this.handleTimeChange({target : {value : data.time}});
        }
        if (data.date && data.date !== ''){
            this.handleDateChange({target : {value : data.date}});
        }

        // On lance le calcul
        var a = setTimeout(this.onClickGo.bind(this), 1000)

    },
    handleFrameTasks : function(e){

        // switch(e.data.typeAction){
        //     case 'dataAndPlot':
        //         console.log(this);
        //         this.getDataAndPlot(e.data);
        //         break;
        //     default:
        //         break;
        // }
    },
    onSwipeComponent  : function(swipedir){
        // swipedir :  "none", "left", "right", "top", or "down"
        if (swipedir ==='up' && this.state.timePickerIsOpen){
            this.props.showAreaFinder();
        }
    },
    showAreaFinder : function(){

        if(!this.state.calculOnProgress){
            this.props.showAreaFinder()
        }

    },
    openTimePicker : function(value){
        this.setState({timePickerIsOpen : value})
    },
    handleDateChange : function(e){
        if (e.target.value){
            this.setState({
                date : e.target.value
            });
            participantService.meetDateAndTime.updateDate(e.target.value)
        }
    },
    handleTimeChange : function(e){
        if (e.target.value){
            this.setState({
                time : e.target.value
            });
            participantService.meetDateAndTime.updateTime(e.target.value)
        }
    },
    onclickOnMap : function(e, canceler){

        if (!this.state.canAddParticipant){
            return;
        }
        if(this.state.calculOnProgress){
            this.props.errorHandler("Des calculs sont en cours !");
            return;
        }

        function handleCanceler(prom){
            return prom
        }

        Promise.all([restService.getBanAdressFromPoint(e.latlng), restService.checklocationvalidity(e.latlng)])
            .then(function(res){

                var banRes = res[0];
                var validityRes = res[1];

                if(banRes.features.length>0 && validityRes.valid) {

                    var tempParticipant = {
                        adress : banRes.features[0].properties.label,
                        coord : {0 : banRes.features[0].geometry.coordinates[0], 1 : banRes.features[0].geometry.coordinates[1]}
                    };

                    var id = participantService.participants.addWithData(tempParticipant);

                    if (id){
                        leafletSrvc.plotParticipant(id, this.onDragParticipant);

                        // console.log(participantService.participants.list);
                        this.setState({
                            participants : participantService.participants.list,
                            legendeList : []
                        }, this.props.updatePosition());
                    }

                    handleCanceler(canceler)
                        .then(function(res){
                             // In case Of double Click
                            if (!res){
                                this.deleteParticipant(id)
                            }
                        }.bind(this))
                }
                else {

                    // gestion error ban && validity
                    if (!validityRes.valid){
                        this.props.errorHandler("Le participant doit être en Ile-de-france !");
                    }
                    else if(banRes.features.length===0) {
                        this.props.errorHandler("Aucune adresse touvée à cet endroit !");
                    }
                    else {
                        this.props.errorHandler("Argg ! Une erreur inconnue s'est produite...");
                    }


                }
            }.bind(this))
            .catch(function(err){
                this.props.errorHandler("Argg ! Une erreur inconnue s'est produite...");
            }.bind(this))

    },
    onDragParticipant : function(e){

        if(this.state.calculOnProgress){
            this.props.errorHandler("Des calculs sont en cours !");
            return;
        }

        this.changeCanAddParticipant(true);

        Promise.all([restService.getBanAdressFromPoint(e.target._latlng), restService.checklocationvalidity(e.target._latlng)])
            .then(function(res){

                var banRes = res[0];
                var validityRes = res[1];

                if(banRes.features.length>0 && validityRes.valid) {

                    var tempParticipant = {
                        adress : banRes.features[0].properties.label,
                        coord : {0 : banRes.features[0].geometry.coordinates[0], 1 : banRes.features[0].geometry.coordinates[1]},
                        id : e.target.options.id
                    };

                    participantService.participants.modifyParticipant(tempParticipant);
                    this.setState({
                        participants : participantService.participants.list,
                        legendeList : []
                    });

                    leafletSrvc.moveParticipant(tempParticipant.id, tempParticipant.coord)

                }
                else{

                    // gestion error ban && validity
                    if (!validityRes.valid){
                        this.props.errorHandler("Le participant doit être en Ile-de-france !");
                        leafletSrvc.moveParticipant(e.target.options.id);
                    }
                    else if(banRes.features.length===0) {
                        this.props.errorHandler("Aucune adresse touvée à cet endroit !");
                        leafletSrvc.moveParticipant(e.target.options.id);
                    }
                    else {
                        this.props.errorHandler("Argg ! Une erreur inconnue s'est produite...");
                        leafletSrvc.moveParticipant(e.target.options.id);
                    }
                }
            }.bind(this))
            .catch(function(err){
                leafletSrvc.moveParticipant(e.target.options.id);
                this.props.errorHandler("Argg ! Une erreur inconnue s'est produite...");
            }.bind(this))


    },
    onClickGo : function(){

        if(!participantService.participants.canBePloted()){
            this.props.errorHandler("Il faut au moins 2 personnes !");
            return;
        }
        if(this.state.calculOnProgress){
            this.props.errorHandler("Des calculs sont en cours !");
            return;
        }


        this.setState({
            canAddParticipant : false,
            calculOnProgress : true
        })

        // this.props.handleWaiter(true);

        if (this.props.position.top === '50px'){
            this.props.handleHidePan();
        }

        leafletSrvc.centerMapOnParticipants();
        leafletSrvc.lunchWaiter();
        leafletSrvc.getAndPlotIsochrones()
            .then(function(res){

                this.setState({
                    canAddParticipant : false,
                    calculOnProgress : false,
                    legendeList : leafletSrvc.getLegendeList()
                })
            }.bind(this))
            .catch(function(err){
                this.setState({
                    canAddParticipant : true,
                    calculOnProgress : false,
                    legendeList : []
                })

                if (err.response && err.response.message && err.response.message === 'Min time > 45 min ! Go on facebook and find closer friends.'){
                    this.props.errorHandler("Temps de trajet supperieur à 45 minutes. Va sur facebook chercher des amis plus proches !");
                }
                else {
                    this.props.errorHandler(null);
                }



            }.bind(this));
    },
    onClickClear : function(){

        if(this.state.calculOnProgress){
            this.props.errorHandler("Des calculs sont en cours !");
            return;
        }

        this.changeCanAddParticipant(true);
        leafletSrvc.clearAll();
        participantService.participants.clearAll();
        participantService.participants.add(2);

        this.setState({
            participants : participantService.participants.list,
            legendeList : []
        }, this.props.updatePosition());

    },
    selectOnMap : function(){
        this.props.showAreaFinder();
    },
    addParticipant : function(){
        this.changeCanAddParticipant(true);
        participantService.participants.add();
        this.setState({
            participants : participantService.participants.list,
            legendeList : []
        }, this.props.updatePosition());

    },
    changeCanAddParticipant : function(can){
        if (this.state.canAddParticipant !==can && (can===true || can===false)){
            this.setState({
                canAddParticipant: can,
            });
        }
        else if(can === undefined){
            this.setState({
                canAddParticipant: !this.state.canAddParticipant,
            });
        }
    },
    deleteParticipant : function(id){

        this.changeCanAddParticipant(true)
        leafletSrvc.unPlotParticipant(id);
        participantService.participants.deleteParticipant(id);

        if (participantService.participants.list.length < 2 ){
            participantService.participants.add();
        }

        this.setState({
            participants : participantService.participants.list,
            legendeList : []
        }, this.props.updatePosition());
    },
    render: function () {

        var renderParticipants = this.state.participants.map(function(item){
            return (
                <ParticipantLine  key={item.id} participantID={item.id} adress={item.adress} handleDrag={this.onDragParticipant}
                                  handleDelete={this.deleteParticipant} selectOnMap={this.selectOnMap} errorHandler={this.props.errorHandler}
                                  watchChange={this.changeCanAddParticipant} timePickerIsOpen={this.openTimePicker} />
            );

        }.bind(this));

        return (
            <div className="areaFinderContentWraper">

                <RightControl onClickGo={this.onClickGo} legendeList={this.state.legendeList} canAddParticipant={this.state.canAddParticipant} onClickMarker={this.changeCanAddParticipant} onClickReset={this.onClickClear} onClickList={this.showAreaFinder} />

                <div className="areaFinderContent" id="areaFinderContent" style={this.props.position} >
                    {renderParticipants}

                    <div className="ligneFlexStartCentered" style={{paddingTop : 5,  paddingBottom : 5}}>

                        {this.state.timePickerIsOpen ? (<TimeContent handleDateChange={this.handleDateChange} handleTimeChange={this.handleTimeChange} time={this.state.time} date={this.state.date} />) : (<div style={{height : 68, width : 150}}></div>) }

                        <div className="flexComponentOne">
                        </div>
                        <div className="ligneFlexCenteredCentered flexComponentNone" style={{color: 'white', textAlign: 'center'}}>
                            <span className="FaActiveToBlack fa fa-plus-circle fa-2x" onClick={this.addParticipant}></span>
                        </div>
                        <div className="flexComponentOne">
                        </div>

                    </div>

                    <div className="ligneFlexCenteredCentered" style={{margin : '15px 0 5px 0'}}>
                        <Button disabled={false} color={"#000000"} fontcolor={"#2fd87d"} minwidth={65} faIcone={""} faIconeSize={""} text={"Go !"} onClick={this.onClickGo} />

                        <div style={{heigth:5, width : 15}}></div>

                        <div style={{height:40, width : 60, boxSizing: 'border-box', marginBottom: -28, overflow: 'hidden'}}>
                                <div style={{marginTop: 20, boxSizing: 'border-box', width : 60, height : 60, borderRadius : 60, backgroundColor : 'white', opacity: 0.5 }}>
                                </div>
                        </div>

                        <div style={{heigth:5, width : 15}}></div>

                        <Button disabled={false} color={"#000000"} fontcolor={"#ff9700"} minwidth={65} faIcone={""} faIconeSize={""} text={"Clear"} onClick={this.onClickClear} />
                    </div>
                </div>



            </div>


        )
    }
});

function swipedetect(el, callback){

    var touchsurface = el,
        swipedir,
        startX,
        startY,
        distX,
        distY,
        dist,
        threshold = 50, //required min distance traveled to be considered swipe
        restraint = 100, // maximum distance allowed at the same time in perpendicular direction
        allowedTime = 300, // maximum time allowed to travel that distance
        elapsedTime,
        startTime,
        handleswipe = callback || function(swipedir){};

    touchsurface.addEventListener('touchstart', function(e){

        var touchobj = e.changedTouches[0];
        swipedir = 'none';
        dist = 0;
        startX = touchobj.pageX;
        startY = touchobj.pageY;
        startTime = new Date().getTime(); // record time when finger first makes contact with surface
        // e.preventDefault()
    }, false);

    // touchsurface.addEventListener('touchmove', function(e){
    //     // e.preventDefault(); // prevent scrolling when inside DIV
    // }, false);

    touchsurface.addEventListener('touchend', function(e){
        var touchobj = e.changedTouches[0];
        distX = touchobj.pageX - startX; // get horizontal dist traveled by finger while in contact with surface
        distY = touchobj.pageY - startY; // get vertical dist traveled by finger while in contact with surface
        elapsedTime = new Date().getTime() - startTime; // get time elapsed
        if (elapsedTime <= allowedTime){ // first condition for awipe met
            if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint){ // 2nd condition for horizontal swipe met
                swipedir = (distX < 0)? 'left' : 'right'; // if dist traveled is negative, it indicates left swipe
            }
            else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint){ // 2nd condition for vertical swipe met
                swipedir = (distY < 0)? 'up' : 'down'; // if dist traveled is negative, it indicates up swipe
            }
            // else{
            //     console.log('Math.abs(distY)', Math.abs(distY));
            //     console.log('threshold', threshold );
            //     console.log('Math.abs(distX)', Math.abs(distX) );
            //     console.log('restraint', restraint );
            //
            // }
        }
        handleswipe(swipedir);
        // e.preventDefault()
    }, false)
}

module.exports = areaFinderContent;


// onClickReset={}


// WEBPACK FOOTER //
// ./src/components/areaFinder/area-finder-content.component.js